import { NpAppointmentType, NpScheduledSession } from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { baseApi } from '../../../data/baseApi'

export type NpSessionSummary = {
  sessionType: NpAppointmentType
  displayName: string
  sequence: number
  blockedReason: string | null
  /** The booked or completed appointment; `null` while the session still needs to be scheduled */
  appointment: NpScheduledSession | null
}

export type NpSessionsResponse = {
  episodeId: string | null
  nextSessionType: NpAppointmentType | null
  lastSessionType: NpAppointmentType | null
  sessions: NpSessionSummary[]
}

type GetNpSessionsArgs = {
  userLyraId: string
}

const npSessionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNpSessions: builder.query<NpSessionsResponse, GetNpSessionsArgs>({
      query: ({ userLyraId }) => ({
        method: 'get',
        url: `/v1/np/calendar/${userLyraId}/sessions`,
        // The member has no NP episode, the flag is off, or the provider is not on the episode (404 or 403):
        // there is no task to show, so no error toast
        showAlert: false,
      }),
    }),
  }),
})

export const { useGetNpSessionsQuery } = npSessionsApi
export default npSessionsApi
